import React, { FC } from 'react';
import styles from './rejectReasonModal.module.scss';
import './rejectReasonModal.scss';
import { Modal, Row } from 'antd';
import COButton from 'shared/components/COButton';
import { ButtonProps } from 'enums/COAlertModal';
import clsx from 'clsx';
import { ReactComponent as CarbonIcon } from 'assets/icons/co2e.svg';
import { ReactComponent as ManufacturerIcon } from 'assets/icons/manufacturer.svg';
import { ReactComponent as BrandIcon } from 'assets/icons/brand_1.svg';
import { Product } from 'models/Product/product.model';
import { generatePath, useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import { modalCloseIcon } from 'shared/components/OrganizationModal';

interface RejectReasonModalProps {
  productDetails?: Product;
  showModal: boolean;
  hideModal: () => void;
  handleViewProduct?: () => void;
}

const RejectReasonModal: FC<RejectReasonModalProps> = props => {
  const { productDetails, showModal, hideModal, handleViewProduct } = props;
  const navigate = useNavigate();
  if (!productDetails) return null;

  const navigateToOverviewPage = () => {
    handleViewProduct?.();
    const path = generatePath(AppRoutes.PRODUCT_OVERVIEW, {
      id: productDetails.id,
    });
    navigate(path);
  };

  return (
    <div
      className={clsx({
        [styles.rejectReasonModal]: true,
      })}>
      <Modal
        width={430}
        footer={
          <div className={styles.footerWrapper}>
            <COButton block onClick={navigateToOverviewPage}>
              View Product
            </COButton>
            <COButton
              color={ButtonProps.COLOR}
              secondary
              loading={false}
              onClick={hideModal}>
              Cancel
            </COButton>
          </div>
        }
        closeIcon={modalCloseIcon}
        open={showModal}
        wrapClassName={clsx({
          [styles.modalContainer]: true,
          ['reject-reason-modal']: true,
        })}
        onCancel={hideModal}>
        <Row className="w-100">
          <div>
            <img
              src={productDetails.image}
              alt=""
              className={styles.productImage}
            />
          </div>
          <div className={styles.productContainer}>
            <div className={styles.productName}>{productDetails.name}</div>
            <span>
              <div className={styles.carbonValueContainer}>
                <div className={styles.carbonIconContainer}>
                  <CarbonIcon className={styles.carbonIcon} />
                </div>
                <div className={styles.carbonValue}>
                  <div className={styles.carbonEmission}>
                    {productDetails.b2c?.toFixed(4)}
                  </div>
                  <div className={styles.carbonString}>
                    kgCO<sub>2</sub>e
                  </div>
                </div>
              </div>
            </span>
          </div>

          <div className={styles.rowTwo}>
            <div className={styles.manufacturerIconContainer}>
              <ManufacturerIcon className={styles.manufacturerIcon} />
            </div>
            <div className={styles.addressLabel}>
              {productDetails.processingFacilityName}
            </div>
          </div>

          <div className={styles.rowThree}>
            <div className={styles.brandContainer}>
              <div className={styles.brandIconContainer}>
                <BrandIcon className={styles.brandIcon} />
              </div>
              <div className={styles.brandNameContainer}>
                {productDetails.brandName}
              </div>
            </div>
          </div>
        </Row>

        <Row>
          <h3>Reason for Decline</h3>
        </Row>

        <Row>
          <p>{productDetails.rejectReason}</p>
        </Row>
      </Modal>
    </div>
  );
};

export default RejectReasonModal;
